import httpClient from '../../httpClient';
import { Question } from 'router/subrouters/DataRoom/models/QAndA';

function editQuestion(
  questionId: string,
  question: Partial<Question>,
  relatedNodeId?: string,
) {
  return httpClient.patch(`/data-room-questions/${questionId}`, {
    ...question,
    dataRoomNodeId: relatedNodeId,
  });
}

function deleteQuestion(qId: string) {
  return httpClient.delete(`/data-room-questions/${qId}`);
}

export default {
  editQuestion,
  deleteQuestion,
};
